import React, { useState, useEffect } from "react";
import api from "../../services/Api";

const Contacto = () => {
  const [form, setForm] = useState({ asunto: "", mensaje: "" });
  const [estado, setEstado] = useState({ enviando: false, ok: "", error: "" });

  const [destino, setDestino] = useState("");
  const [buscar, setBuscar] = useState("");
  const [agenda, setAgenda] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [errorAgenda, setErrorAgenda] = useState("");
  useEffect(() => {
    let vigente = true;
    setCargando(true);
    setErrorAgenda("");
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.get("/Contacto/destinatarios", { params: { buscar } });
        if (vigente) { setAgenda(data); setCargando(false); }
      } catch {
        if (vigente) { setErrorAgenda("No se pudieron cargar los destinatarios. Actualiza la página para reintentar."); setCargando(false); }
      }
    }, 250);
    return () => { vigente = false; clearTimeout(timer); };
  }, [buscar]);

  const enviar = async (e) => {
    e.preventDefault();
    if (estado.enviando || cargando || errorAgenda || !agenda) return;
    setEstado({ enviando: true, ok: "", error: "" });
    try {
      const respuesta = await api.post("/Contacto/enviar", { asunto: form.asunto.trim(), mensaje: form.mensaje.trim(), destinatarioUsuarioId: destino ? Number(destino) : null });
      setForm({ asunto: "", mensaje: "" });
      setEstado({ enviando: false, ok: respuesta?.data?.mensaje || "Mensaje enviado correctamente.", error: "" });
    } catch (error) {
      const detalle = error?.response?.data?.error || error?.response?.data?.title || "No fue posible enviar el mensaje.";
      setEstado({ enviando: false, ok: "", error: detalle });
    }
  };

  return (
    <div className="relative overflow-hidden rounded-2xl border border-emerald-500/20 bg-[#071014]/90 text-white">
      <section className="relative border-t border-white/10 bg-black/20 px-5 py-12 sm:px-10 lg:px-16">
        <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[.8fr_1.2fr]">
          <div>
            <span className="text-sm font-semibold uppercase tracking-[.25em] text-cyan-300">Hablemos</span>
            <h1 className="mt-3 text-3xl font-black sm:text-4xl">Tu experiencia también construye el sistema.</h1>
            <p className="mt-5 leading-7 text-slate-400">
              ¿Tienes una consulta, encontraste un problema o imaginas una mejora? Escríbenos desde aquí.
              El mensaje llegará identificado con el nombre y correo de tu cuenta.
            </p>
            <div className="mt-7 rounded-2xl border border-cyan-500/20 bg-cyan-500/5 p-5 text-sm text-slate-300">
              <strong className="text-cyan-300">Respuesta directa</strong>
              <p className="mt-1 text-slate-400">El destinatario podrá responder al correo asociado con tu usuario.</p>
            </div>
          </div>

          <form onSubmit={enviar} className="rounded-3xl border border-emerald-500/25 bg-slate-950/70 p-5 shadow-2xl backdrop-blur sm:p-8">
            <label htmlFor="contacto-destino" className="block text-sm font-semibold text-emerald-300">Enviar a</label>
            {agenda && !agenda.esTemporal && <input aria-label="Buscar usuario temporal" value={buscar}
              disabled={estado.enviando} onChange={(e) => { setBuscar(e.target.value); setDestino(""); }}
              placeholder="Buscar uno de mis usuarios temporales por nombre o correo"
              className="mt-2 w-full rounded-xl border border-slate-700 bg-[#09161c] px-4 py-3 text-white" />}
            <select id="contacto-destino" value={destino} onChange={(e) => setDestino(e.target.value)}
              disabled={cargando || estado.enviando || !!errorAgenda}
              className="mt-2 w-full rounded-xl border border-slate-700 bg-[#09161c] px-4 py-3 text-white">
              <option value="">Administrador del servicio — {agenda?.servicio || "sistemapiscicultura@gmail.com"}</option>
              {agenda?.contactos?.map((c) => <option key={c.id} value={String(c.id)}>
                {agenda.esTemporal ? "Administrador de mi cuenta" : "Usuario temporal"}: {c.nombre} — {c.correo}
              </option>)}
            </select>
            {cargando && <p role="status" className="mt-2 text-sm text-slate-400">Cargando destinatarios…</p>}
            {errorAgenda && <p role="alert" className="mt-2 text-red-300">{errorAgenda}</p>}
            {agenda?.hayMas && <p className="mt-2 text-sm text-slate-400">Hay más usuarios. Escribe su nombre o correo para encontrarlos.</p>}
            {agenda && !cargando && agenda.contactos.length === 0 && <p className="mt-2 text-sm text-slate-400">No se encontraron contactos de tu cuenta.</p>}
            <div className="mt-6" />
            <label htmlFor="contacto-asunto" className="block text-sm font-semibold text-emerald-300">Asunto</label>
            <input id="contacto-asunto" required minLength={3} maxLength={120} value={form.asunto}
              onChange={(e) => setForm((f) => ({ ...f, asunto: e.target.value }))}
              placeholder="¿En qué podemos ayudarte?"
              className="mt-2 w-full rounded-xl border border-slate-700 bg-[#09161c] px-4 py-3 text-white outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-500/20" />

            <label htmlFor="contacto-mensaje" className="mt-6 block text-sm font-semibold text-emerald-300">Mensaje</label>
            <textarea id="contacto-mensaje" required minLength={10} maxLength={4000} rows={7} value={form.mensaje}
              onChange={(e) => setForm((f) => ({ ...f, mensaje: e.target.value }))}
              placeholder="Cuéntanos con detalle tu consulta, sugerencia o inconveniente…"
              className="mt-2 w-full resize-y rounded-xl border border-slate-700 bg-[#09161c] px-4 py-3 text-white outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-500/20" />
            <div className="mt-1 text-right text-xs text-slate-500">{form.mensaje.length}/4000</div>

            {estado.ok && <div role="status" className="mt-4 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-emerald-300">✓ {estado.ok}</div>}
            {estado.error && <div role="alert" className="mt-4 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-red-300">{estado.error}</div>}

            <button type="submit" disabled={estado.enviando || cargando || !!errorAgenda || !agenda}
              className="mt-6 w-full rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-600 px-5 py-3.5 font-bold text-white shadow-lg shadow-emerald-950/50 transition hover:brightness-110 disabled:cursor-wait disabled:opacity-60">
              {estado.enviando ? "Enviando mensaje…" : "Enviar mensaje"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contacto;
